export const RelatedObjectsTypes = {
  ORDER: 'order',
  CUSTOMER: 'customer',
  INVENTORY: 'inventory',
  CATALOG: 'catalog',
} as const;

export type RelatedObjectType =
  (typeof RelatedObjectsTypes)[keyof typeof RelatedObjectsTypes];

export const RELATED_OBJECTS_OPTIONS = [
  RelatedObjectsTypes.ORDER,
  RelatedObjectsTypes.CUSTOMER,
  RelatedObjectsTypes.INVENTORY,
  RelatedObjectsTypes.CATALOG,
] as const;

export const CustomFieldTypes = {
  TEXT: 'text',
  RICH_TEXT: 'rich_text',
  NUMBER: 'number',
  DECIMAL: 'decimal',
  DATE: 'date',
  BOOLEAN: 'boolean',
  SINGLE_SELECT: 'single_select',
  MULTI_SELECT: 'multi_select',
  URL: 'url',
  EMAIL: 'email',
} as const;

export type CustomFieldType = (typeof CustomFieldTypes)[keyof typeof CustomFieldTypes];

export const CUSTOM_FIELD_TYPES_OPTIONS = [
  CustomFieldTypes.TEXT,
  CustomFieldTypes.RICH_TEXT,
  CustomFieldTypes.NUMBER,
  CustomFieldTypes.DECIMAL,
  CustomFieldTypes.DATE,
  CustomFieldTypes.BOOLEAN,
  CustomFieldTypes.SINGLE_SELECT,
  CustomFieldTypes.MULTI_SELECT,
  CustomFieldTypes.URL,
  CustomFieldTypes.EMAIL,
] as const;

export const CustomFieldVisibilityTypes = {
  ALL: 'all',
  BACKOFFICE: 'backoffice',
  DOCUMENTS: 'documents',
  B2B_PORTAL: 'b2b_portal',
  AGENT_PORTAL: 'agent_portal',
} as const;

export type CustomFieldVisibilityType =
  (typeof CustomFieldVisibilityTypes)[keyof typeof CustomFieldVisibilityTypes];

export const CUSTOM_FIELD_VISIBILITY_OPTIONS = [
  CustomFieldVisibilityTypes.BACKOFFICE,
  CustomFieldVisibilityTypes.DOCUMENTS,
  CustomFieldVisibilityTypes.B2B_PORTAL,
  CustomFieldVisibilityTypes.AGENT_PORTAL,
] as const;

